export default {
  code: 'کد',
  name: 'نام',
  save: 'ذخیره',
  enter: 'ورود',
  submit: 'ارسال',
  goBack: 'بازگشت',
  getCode: 'دریافت کد',
  profile: 'نمایه',
  phoneNumber: 'شماره‌ی همراه',
  phoneNumberWithHint: 'شماره‌ی همراه (مثال: ۹۱۲۳۴۵۶۷۸۹)',
  phoneNumberChanged: 'شماره تماس با موفقیت تغییر کرد',
  profileNameNotChanged: 'نام پروفایل شما تغییر نکرده است',
  userUpdatedSuccessfully: 'کاربر با موفقیت بروزرسانی شد',
  phoneNumberIsSameAsBefore: 'با همین شماره ثبت‌نام کرده‌اید',
  enterPhoneNumber:
    'لطفاً شماره‌ی تلفن همراه خود را وارد کنید تا کد ثبت‌نام برای شما ارسال شود.',
  hasLowerCase: 'حروف کوچک انگلیسی',
  hasUpperCase: 'حروف بزرگ انگلیسی',
  hasDigit: 'اعداد انگلیسی',
  hasSpecial: 'یکی از حروف ~ ! @ # $ % ^ & * ( ) - = + ? :',
  has8chars: 'طول ۸ کاراکتر',
  password: 'کلمه عبور',
  passwordAgain: 'تکرار کلمه عبور',
  changePassword: 'تغییر کلمه عبور',
  setPassword: 'ثبت کلمه عبور',
  matches: 'منطبق با یکدیگر',
  passwordChanged: 'کلمه عبور جدید شما ثبت شد',
  yourUsing2fa: 'شما از ورود دو مرحله ای استفاده می‌کنید',
  enable2fa: 'فعال سازی ورود دو مرحله ای',
  disable2fa: 'غیر فعال سازی ورود دو مرحله ای',
  yourShouldSetPhoneFor2FA:
    'برای فعال سازی ورود دو مرحله ای باید تلفن خود را وارد کنید',
  yourShouldSetPasswordFor2FA:
    'برای فعال سازی ورود دو مرحله ای باید برای حساب خود کلمه عبور بگذارید',
  enterPasswordFor2FA: 'لطفا کلمه عبور خود را وارد کنید',
  managePassword: 'مدیریت کلمه عبور',
  manage2fa: 'ورود امن دو مرحله ای',
  cancel: 'لغو',
  personalInfo: 'اطلاعات شخصی',
  the2faActivated: 'ورود دو مرحله‌ای فعال شد',
  the2faDeactivated: 'ورود دو مرحله‌ای غیر فعال شد',
  active: 'فعال',
  inactive: 'غیر فعال',
  managingPhoneNumber: 'مدیریت شماره تلفن',
  date: 'تاریخ',
  loginHistory: 'تاریخچه ورود',
  authentication: 'احراز هویت',
  basicInfo: 'اطلاعات پایه',
  advancedSettings: 'تنظیمات پیشرفته',
  useBeta: 'استفاده از نسخه پیشرو',
  reloadOnBeta: 'به منظور اعمال تغییرات سامانه دوباره بارگیری خواهد شد',
  change: 'تغییر',
  confirmCode: 'کد تأیید',
  confirm: 'تأیید',
  Authenticate_Mobile: 'ورود با استفاده از تلفن همراه',
  TryAuthenticate_Mobile: '',
  TryAuthenticate_2fa: '',
  Authenticate_Pass: 'ورود با نام کاربری و کلمه عبور',
  Authenticate_2FA: '',
  Authenticate_SAC: 'ورود با کد یکبار مصروف',
  Unsuccessful_Authenticate_Mobile: 'ورود ناموفق با تلفن همراه',
  Unsuccessful_Authenticate_Pass: 'ورود ناموفق با کلمه عبور',
  Unsuccessful_Authenticate_2FA: 'ورود ناموفق دوعاملی',
  Unsuccessful_Authenticate_SAC: 'ورود نا موفق با کد یکبار مصرو',
  Successful_Registration: 'ثبت نام موفق',
  Unsuccessful_Registration: '',
  Inconsistency: '',
  Role_Add: '',
  Role_Remove: '',
  NotifyLogout: 'خروج یکپارچه',
  Renew_Token: '',
  User_Blocked: 'مسدودی حساب',
  User_UnBlocked: 'رفع مسدودی حساب',
  Authorized_Security_Logs: '',
  Unauthorized_Security_Logs: '',
  Successful_Config: '',
  Unsuccessful_Config: '',
  Change_Phone: 'تغییر شماره تلفن',
  Change_Password: 'تغییر کلمه عبور',
  User_Deleted: '',
  User_Restored: '',
  User_Enabled: 'فعال سازی حساب',
  User_Disabled: 'غیر فعال سازی حساب',
  Enable_2FA: 'فعال سازی ورود دو مرحله‌ای',
  Disable_2FA: 'غیر فعال سازی ورود دو مرحله‌ای',
};
